// extracted by mini-css-extract-plugin
module.exports = {"warning":"warning___2gcA2"};